import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetCategoryNavigationTreeResult } from "@insite/client-framework/Services/CategoryService";
import { NavigationTreeState } from "@insite/client-framework/Store/Data/NavigationTree/NavigationTreeState";
import { Draft } from "immer";

const initialState: NavigationTreeState = {
    treesByRootId: {},
    loadedDepthByRootId: {},
    isLoadingByRootId: {},
    rootIdsCalled: [],
    errorStatusCodeByRootId: {},
};

const reducer = {
    "Data/NavigationTree/BeginLoad": (draft: Draft<NavigationTreeState>, action: { rootId: string }) => {
        draft.isLoadingByRootId[action.rootId] = true;
        if (!draft.rootIdsCalled.includes(action.rootId)) {
            draft.rootIdsCalled.push(action.rootId);
        }
    },

    "Data/NavigationTree/CompleteLoad": (
        draft: Draft<NavigationTreeState>,
        action: { result: GetCategoryNavigationTreeResult },
    ) => {
        const { rootId, maxDepth, node } = action.result;
        delete draft.isLoadingByRootId[rootId];
        if ((draft.loadedDepthByRootId[rootId] || 0) <= maxDepth) {
            draft.treesByRootId[rootId] = node;
            draft.loadedDepthByRootId[rootId] = maxDepth;
        }
    },

    "Data/NavigationTree/FailedToLoad": (
        draft: Draft<NavigationTreeState>,
        action: { rootId: string; status: number },
    ) => {
        delete draft.isLoadingByRootId[action.rootId];
        draft.errorStatusCodeByRootId[action.rootId] = action.status;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
